<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 px-4"
    style="top: -64px; height: calc(100% + 64px);"
  >
    <div class="w-full max-w-2xl rounded-xl bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-neutral-200 px-6 py-4">
        <h2 class="text-lg font-semibold text-neutral-800">Crear Grupo</h2>
        <button
          class="text-neutral-400 hover:text-neutral-600"
          @click="$emit('close')"
          :disabled="isCreating"
        >
          ✕
        </button>
      </div>

      <div class="px-6 py-5 space-y-4">
        <div>
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            Nombre del Grupo
          </label>
          <input
            :value="form.name"
            :disabled="isCreating"
            type="text"
            placeholder="Ej. Grupo Gamma"
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('name', $event.target.value)"
          />
          <p v-if="showValidation && !form.name" class="text-sm text-red-600 mt-1">
            El nombre es obligatorio.
          </p>
        </div>

        <div>
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            Descripción
          </label>
          <textarea
            :value="form.description"
            :disabled="isCreating"
            rows="3"
            placeholder="Descripción opcional"
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('description', $event.target.value)"
          ></textarea>
        </div>
      </div>

      <div class="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4">
        <button
          class="rounded-md border border-neutral-300 px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
          @click="$emit('close')"
          :disabled="isCreating"
        >
          Cancelar
        </button>
        <button
          class="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700 disabled:opacity-60"
          @click="$emit('create')"
          :disabled="!canCreate || isCreating"
        >
          <span v-if="isCreating" class="inline-flex items-center">
            <span class="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent"></span>
            Creando...
          </span>
          <span v-else>Crear Grupo</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeacherCreateGroupModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    isCreating: {
      type: Boolean,
      default: false,
    },
    showValidation: {
      type: Boolean,
      default: false,
    },
    canCreate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    emitUpdate(field, value) {
      this.$emit("update-field", { field, value });
    },
  },
};
</script>
